// extracted by mini-css-extract-plugin
module.exports = {"user_item":"transfer_user_item__UNlT7","search_list":"transfer_search_list__2v-D4"};